/* eslint-disable no-use-before-define */
import React from 'react'
import _ from 'lodash'
import { Document, StyleSheet, Page, View, Text, Image, Font } from '@react-pdf/renderer'
import muuveLogo from '../../assets/images/muuve-logo-2.png'
import Table from './shared/Table'
import Signature from './shared/Signature'

import MontserratFont from '../../assets/fonts/Montserrat-Regular.ttf'
import MontserratFontBoldFont from '../../assets/fonts/Montserrat-Bold.ttf'
import NokoraFont from '../../assets/fonts/Nokora-Regular.ttf'
import NokoraBoldFont from '../../assets/fonts/Nokora-Bold.ttf'

Font.register({ family: 'Montserrat', src: MontserratFont })
Font.register({ family: 'Montserrat Bold', src: MontserratFontBoldFont })
Font.register({ family: 'Nokora', src: NokoraFont })
Font.register({ family: 'Nokora Bold', src: NokoraBoldFont })

const TaxInvoiceReport = () => {
  const params = JSON.parse(localStorage.getItem('invoiceState'))

  const {
    startFrom,
    endAt,
    invoiceNumber,
    invoiceDateEn,
    invoiceDateKh,
    subtotal: subtotalObject,
    rielRate,
    commissionRate,
    officialInfo = {},
  } = params

  const { address = {}, name = {}, vattin = '' } = officialInfo

  const { en: addressEn = '', kh: addressKh = '' } = address
  const { en: companyNameEn = '', kh: companyNameKh = '' } = name

  const subtotalWithCommissionRate = _.reduce(
    subtotalObject,
    (accum, value, key) => {
      accum[key] = value * (commissionRate / 100)
      return accum
    },
    {}
  )

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View fixed style={styles.header} />
        <View id="p1dimg1" style={styles.p1dimg1}>
          <Image style={styles.p1img1} src={muuveLogo} id="p1img1" />
        </View>
        <View>
          <Text style={{ ...styles.p0, ...fonts.ft0 }}>
            <Text>ក្រុមហ៊ុន ម៉ូវ</Text> <Text>ថេក ឯ.ក </Text>
          </Text>
          <Text style={{ ...styles.p1, ...fonts.ft1 }}>MUUVE TECH CO., LTD</Text>
          <Text style={{ ...styles.p2, ...fonts.ft2 }}>
            <Text style={{ ...fonts.ft4 }}>លេខអត្តសញ្ញាណកម្ម អតប </Text>{' '}
            <Text style={{ ...fonts.ft2, ...styles.span }}>(VATTIN)</Text>{' '}
            <Text style={{ ...fonts.ft3, ...styles.span }}>K003-902001627</Text>{' '}
          </Text>
          <View style={{ ...styles.p2 }}>
            <Text style={{ ...fonts.ft4 }}>
              <Text>អាសយដ្ឋាន: {'   '}</Text>
              <Text>ផ្ទះលេខ៤៥ - ៤៧, {'   '}</Text>
              <Text>ផ្លូវលេខ៥៣, {'   '}</Text>
              <Text>សង្កាត់ ផ្សារថ្មី២,{'   '}</Text>
            </Text>
            <Text style={{ ...fonts.ft4 }}>
              ខណ្ឌ ដូនពេញ, រាជធានី ភ្នំពេញ. លេខទូរស័ព្ទ: ០១៥ ៩៤ ៩៤ ០៤{'      '}
            </Text>
          </View>
        </View>

        <View style={{ ...tableStyles.t0 }}>
          <View style={{ borderTop: 1, marginTop: 20 }} />
          <View style={{ ...tableStyles.tr }}>
            <View style={{ ...styles.p5 }}>
              <Text style={{ ...fonts.ft0 }}>
                <Text>វិក្កយបត្រ</Text>
                <Text>អាករ</Text>
              </Text>
              <Text style={{ ...fonts.ft1 }}>TAX INVOICE</Text>
            </View>
          </View>

          <View style={{ ...tableStyles.tr }}>
            <View style={{ width: 200 }}>
              <Text style={{ ...tableStyles.td }}>
                <Text style={{ ...styles.p7, ...fonts.ft4 }}>
                  <Text>ឈ្មោះក្រុមហ៊ុន</Text>
                  <Text>ឬ អតិថិជន: </Text>
                  <Text>
                    {companyNameKh}
                    {'   '}
                  </Text>
                </Text>
              </Text>

              <View style={{ ...tableStyles.td, paddingBottom: 5 }}>
                <Text style={{ ...styles.p7, ...fonts.ft2 }}>
                  <Text>Company /</Text>
                  <Text> Customer: ​</Text>
                  <Text>{companyNameEn}</Text>
                </Text>
              </View>
              <View style={{ ...tableStyles.tr5, ...tableStyles.td, width: 180 }}>
                <View style={{ ...tableStyles.tr, ...tableStyles.spacingRow }}>
                  <Text style={{ ...styles.p7, ...fonts.ft4 }}>
                    <Text>អាសយដ្ឋាន: </Text>
                    <Text>
                      {addressKh}
                      {'         '}
                    </Text>
                  </Text>
                </View>
              </View>
              <View style={{ ...tableStyles.td }}>
                <View style={{ ...tableStyles.tr, ...tableStyles.spacingRow }}>
                  <Text style={{ ...styles.p7, ...fonts.ft2 }}>
                    <Text>Address: </Text>
                    <Text>{addressEn}</Text>
                  </Text>
                </View>
              </View>
              <View style={{ ...tableStyles.td, width: 1 }}>
                <Text style={{ ...styles.p7 }}>
                  <Text style={{ ...fonts.ft4 }}>លេខអត្តសញ្ញាណកម្ម អតប </Text>
                  <Text style={{ ...styles.span, ...fonts.ft2 }}>(VATTIN): </Text>
                  <Text style={{ ...styles.span, ...fonts.ft2 }}>{vattin}</Text>
                  <Text style={{ ...styles.span, ...fonts.ft12 }}>{/* L001-100045065 */}</Text>
                </Text>
              </View>
            </View>

            <View style={{ width: 200, marginRight: 5, textAlign: 'right' }}>
              <View>
                <Text style={{ ...fonts.ft4 }}>
                  <Text>លេខរៀងវិក្កយបត្រ៖{'   '}</Text>
                </Text>
              </View>
              <View>
                <Text style={{ ...fonts.ft2 }}>
                  <Text>Invoice Number:</Text>
                </Text>
              </View>

              <View>
                <Text style={{ ...fonts.ft4 }}>
                  <Text>កាលបរិច្ឆេទ:{'       '}</Text>
                </Text>
              </View>
              <View>
                <Text style={{ ...fonts.ft2 }}>Date:</Text>
              </View>
            </View>

            <View style={{ width: 60, textAlign: 'left' }}>
              <View>
                <Text style={{ ...fonts.ft4 }}>
                  <Text>{invoiceNumber}</Text>
                </Text>
              </View>
              <View>
                <Text style={{ ...fonts.ft2 }}>
                  <Text>{invoiceNumber}</Text>
                </Text>
              </View>

              <View>
                <Text style={{ ...fonts.ft4 }}>
                  <Text>{invoiceDateKh}</Text>
                </Text>
              </View>
              <View>
                <Text style={{ ...fonts.ft2 }}>
                  <Text>{invoiceDateEn}</Text>
                </Text>
              </View>
            </View>
          </View>
          <View style={{ ...tableStyles.tr }} />

          <View style={{ ...tableStyles.tr }} />

          <View style={{ ...tableStyles.tr }} />

          <View style={{ ...tableStyles.tr, ...tableStyles.spacingRow }} />
        </View>

        <Table
          startFrom={startFrom}
          endAt={endAt}
          type="tax"
          subtotal={subtotalWithCommissionRate}
          rielRate={rielRate}
        />

        <View wrap={false}>
          <Signature />
          <View wrap={false} style={{ marginLeft: 50, marginTop: 10 }}>
            <Text style={{ ...fonts.ft4, marginTop: 20 }}>
              សំគាល់ : វិក្កយបត្រច្បាប់ដើមសម្រាប់អតិថិជន ច្បាប់ចម្លងសម្រាប់អ្នកលក់{'   '}
            </Text>
            <Text style={{ ...styles.span, ...fonts.ft2 }}>
              Note: Original invoice for customer, copied for seller
            </Text>
          </View>
        </View>

        <View fixed style={styles.footer} />
      </Page>
    </Document>
  )
}

const tableStyles = StyleSheet.create({
  t0: {
    width: 450,
    marginLeft: 60,
    marginTop: 2,
    fontSize: 12,
    fontFamily: 'Montserrat',
  },
  trFlex: { display: 'flex', flexDirection: 'row' },
  colFlex: { display: 'flex', flexDirection: 'column' },
  tr: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between' },
  tableRow: { marginLeft: 78, width: 480 },
  spacingRow: { height: 30 },

  td: { padding: 0, margin: 0, verticalAlign: 'bottom' },
  td1: { width: 150 },
  td5: { width: 200 },
  td12: { width: 125 },
  td23: {
    borderColor: '#000000',
    borderRight: 1,
    width: 55,
  },
  td29: {
    borderRight: 1,
    borderColor: '#000000',
    width: 55,
    backgroundColor: '#ffe599',
    textAlign: 'center',
  },
  td25: {
    borderRight: 1,
    borderColor: '#000000',
    width: 30,
    backgroundColor: '#ffe599',
    textAlign: 'center',
  },
  td41: {
    borderColor: '#000000',
    borderRight: 1,
    width: 30,
  },
  td28: {
    borderRight: 1,
    borderColor: '#000000',
    width: 272,
    backgroundColor: '#ffe599',
    textAlign: 'center',
  },
  td17: {
    borderRight: 1,
    borderColor: '#000000',
    width: 272,
  },
  td31: {
    borderRight: 1,
    borderColor: '#000000',
    width: 75,
    backgroundColor: '#ffe599',
    textAlign: 'center',
  },
  td56: {
    borderColor: '#000000',
    borderRight: 1,
    width: 75,
  },
  td32: {
    width: 70,
    backgroundColor: '#ffe599',
    textAlign: 'center',
  },
  // td130: {
  //   borderColor: '#000000',
  //   borderRight: 1,
  //   width: 130,
  // },
  td100: { width: 100 },
  tr3: { height: 16 },
  tr7: { height: 40, display: 'flex', justifyContent: 'center' },

  td302: { borderColor: '#000000', borderRight: 1, width: 302, paddingLeft: 5 },
  td57: { width: 70 },

  tr5: { height: 30, display: 'flex', justifyContent: 'center' },
})
const fonts = StyleSheet.create({
  ft0: {
    fontSize: 16,
    fontFamily: 'Nokora Bold',
  },
  ft1: {
    fontSize: 14,
    fontFamily: 'Montserrat',
  },
  ft2: {
    fontSize: 9,
    fontFamily: 'Montserrat',
  },
  ft3: {
    fontSize: 9,
    fontFamily: 'Montserrat Bold',
  },
  ft4: {
    fontSize: 9,
    fontFamily: 'Nokora',
  },
  ft8: {
    fontSize: 9,
    fontFamily: 'Nokora Bold',
  },
  ft12: {
    fontSize: 9,
    fontFamily: 'Montserrat',
    color: '#232222',
  },
})

const styles = StyleSheet.create({
  page: {
    paddingBottom: 45,
  },
  header: {
    marginTop: 50,
    backgroundColor: 'red',
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    marginBottom: 45,
    backgroundColor: 'green',
  },
  p1dimg1: {
    width: 200,
    position: 'absolute',
    top: -55,
    left: 50,
    zIndex: -1,
  },
  p1img1: {
    width: 250,
  },

  p0: {
    textAlign: 'right',
    paddingRight: 75,
    marginTop: 0,
    marginBottom: 0,
  },
  p1: {
    textAlign: 'right',
    paddingRight: 75,
    marginTop: 5,
    marginBottom: 0,
  },
  p2: {
    textAlign: 'right',
    paddingRight: 75,
    marginBottom: 0,
  },
  p3: {
    textAlign: 'left',
    paddingLeft: 259,
    marginTop: 2,
    marginBottom: 0,
  },
  p4: {
    textAlign: 'left',
    paddingLeft: 461,
    marginTop: 0,
    marginBottom: 0,
  },
  p5: {
    textAlign: 'center',
    marginTop: 10,
    marginBottom: 10,
  },
  p6: {
    textAlign: 'center',
    marginTop: 5,
    marginBottom: 0,
  },
  p7: {
    textAlign: 'left',
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p8: {
    textAlign: 'right',
    // paddingRight: 144,
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p9: {
    textAlign: 'left',
    paddingLeft: 40,
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p12: {
    textAlign: 'left',
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },

  p13: {
    textAlign: 'left',
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p14: {
    textAlign: 'center',
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p15: {
    textAlign: 'left',
    paddingLeft: 31,
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p16: {
    textAlign: 'left',
    paddingLeft: 11,
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p17: {
    textAlign: 'left',
    paddingLeft: 150,
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p18: {
    textAlign: 'left',
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p19: {
    textAlign: 'left',
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },

  pLeftTop: {
    paddingTop: 5,
    paddingLeft: 5,
  },
  span: {
    display: 'inline',
  },
})
export default TaxInvoiceReport



// WEBPACK FOOTER //
// ./src/components/invoice/TaxInvoiceReport.js